import { P as $, b as p, n as h, t as y } from "./element-CV9utnHJ.js";
import { P as C } from "./pkt-slot-controller-D7CrjM52.js";
import { r as w } from "./state-l4hGZdFJ.js";
import { e as x, n as f } from "./ref-Dma3n3i8.js";
import { o as u } from "./if-defined-rXcLNTzN.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let P = class extends Event {
  constructor(t, s, i, e) {
    super("context-request", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = s, this.callback = i, this.subscribe = e ?? !1;
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let m = class {
  constructor(t, s, i, e) {
    if (this.subscribe = !1, this.provided = !1, this.value = void 0, this.t = (n, r) => {
      this.unsubscribe && (this.unsubscribe !== r && (this.provided = !1, this.unsubscribe()), this.subscribe || this.unsubscribe()), this.value = n, this.host.requestUpdate(), this.provided && !this.subscribe || (this.provided = !0, this.callback && this.callback(n, r)), this.unsubscribe = r;
    }, this.host = t, s.context !== void 0) {
      const n = s;
      this.context = n.context, this.callback = n.callback, this.subscribe = n.subscribe ?? !1;
    } else this.context = s, this.callback = i, this.subscribe = e ?? !1;
    this.host.addController(this);
  }
  hostConnected() {
    this.dispatchRequest();
  }
  hostDisconnected() {
    this.unsubscribe && (this.unsubscribe(), this.unsubscribe = void 0);
  }
  dispatchRequest() {
    this.host.dispatchEvent(new P(this.context, this.host, this.t, this.subscribe));
  }
};
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class _ {
  get value() {
    return this.o;
  }
  set value(t) {
    this.setValue(t);
  }
  setValue(t, s = !1) {
    const i = s || !Object.is(t, this.o);
    this.o = t, i && this.updateObservers();
  }
  constructor(t) {
    this.subscriptions = /* @__PURE__ */ new Map(), this.updateObservers = () => {
      for (const [s, { disposer: i }] of this.subscriptions) s(this.o, i);
    }, t !== void 0 && (this.value = t);
  }
  addCallback(t, s, i) {
    if (!i) return void t(this.value);
    this.subscriptions.has(t) || this.subscriptions.set(t, { disposer: () => {
      this.subscriptions.delete(t);
    }, consumerHost: s });
    const { disposer: e } = this.subscriptions.get(t);
    t(this.value, e);
  }
  clearCallbacks() {
    this.subscriptions.clear();
  }
}
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
let N = class extends Event {
  constructor(t, s) {
    super("context-provider", { bubbles: !0, composed: !0 }), this.context = t, this.contextTarget = s;
  }
};
class g extends _ {
  constructor(t, s, i) {
    var e, n;
    super(s.context !== void 0 ? s.initialValue : i), this.onContextRequest = (r) => {
      if (r.context !== this.context) return;
      const a = r.contextTarget ?? r.composedPath()[0];
      a !== this.host && (r.stopPropagation(), this.addCallback(r.callback, a, r.subscribe));
    }, this.onProviderRequest = (r) => {
      if (r.context !== this.context || (r.contextTarget ?? r.composedPath()[0]) === this.host) return;
      const a = /* @__PURE__ */ new Set();
      for (const [v, { consumerHost: k }] of this.subscriptions) a.has(v) || (a.add(v), k.dispatchEvent(new P(this.context, k, v, !0)));
      r.stopPropagation();
    }, this.host = t, s.context !== void 0 ? this.context = s.context : this.context = s, this.attachListeners(), (n = (e = this.host).addController) == null || n.call(e, this);
  }
  attachListeners() {
    this.host.addEventListener("context-request", this.onContextRequest), this.host.addEventListener("context-provider", this.onProviderRequest);
  }
  hostConnected() {
    this.host.dispatchEvent(new N(this.context, this.host));
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function R({ context: o }) {
  return (t, s) => {
    const i = /* @__PURE__ */ new WeakMap();
    if (typeof s == "object") return { get() {
      return t.get.call(this);
    }, set(e) {
      return i.get(this).setValue(e), t.set.call(this, e);
    }, init(e) {
      return i.set(this, new g(this, { context: o, initialValue: e })), e;
    } };
    {
      t.constructor.addInitializer(((r) => {
        i.set(r, new g(r, { context: o }));
      }));
      const e = Object.getOwnPropertyDescriptor(t, s);
      let n;
      if (e === void 0) {
        const r = /* @__PURE__ */ new WeakMap();
        n = { get() {
          return r.get(this);
        }, set(a) {
          i.get(this).setValue(a), r.set(this, a);
        }, configurable: !0, enumerable: !0 };
      } else {
        const r = e.set;
        n = { ...e, set(a) {
          i.get(this).setValue(a), r == null || r.call(this, a);
        } };
      }
      return void Object.defineProperty(t, s, n);
    }
  };
}
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function A({ context: o, subscribe: t }) {
  return (s, i) => {
    typeof i == "object" ? i.addInitializer((function() {
      new m(this, { context: o, callback: (e) => {
        s.set.call(this, e);
      }, subscribe: t });
    })) : s.constructor.addInitializer(((e) => {
      new m(e, { context: o, callback: (n) => {
        e[i] = n;
      }, subscribe: t });
    }));
  };
}
const S = Symbol("pkt-tabs-context");
var O = Object.defineProperty, T = Object.getOwnPropertyDescriptor, d = (o, t, s, i) => {
  for (var e = i > 1 ? void 0 : i ? T(t, s) : t, n = o.length - 1, r; n >= 0; n--)
    (r = o[n]) && (e = (i ? r(t, s, e) : r(e)) || e);
  return i && e && O(t, s, e), e;
};
let b = class extends $ {
  constructor() {
    super(), this.arrowNav = !0, this.disableArrowNav = !1, this.tabRefs = [], this.tabCount = 0, this.defaultSlot = x(), this.context = {
      useArrowNav: this.useArrowNav,
      registerTab: this.registerTab.bind(this),
      handleClick: this.handleClick.bind(this),
      handleKeyUp: this.handleKeyUp.bind(this)
    }, this.slotController = new C(this, this.defaultSlot);
  }
  get useArrowNav() {
    return this.arrowNav && !this.disableArrowNav;
  }
  // Update context when properties change
  updated(o) {
    (o.has("arrowNav") || o.has("disableArrowNav")) && (this.context = {
      ...this.context,
      useArrowNav: this.useArrowNav
    });
  }
  registerTab(o, t) {
    this.tabRefs[t] = o, this.tabCount = Math.max(this.tabCount, t + 1);
  }
  handleClick(o) {
    this.dispatchEvent(
      new CustomEvent("tab-selected", {
        detail: { index: o },
        bubbles: !0,
        composed: !0
      })
    );
  }
  handleKeyUp(o, t) {
    var s, i;
    this.useArrowNav && (o.code === "ArrowLeft" && t !== 0 && ((s = this.tabRefs[t - 1]) == null || s.focus()), o.code === "ArrowRight" && t < this.tabCount - 1 && ((i = this.tabRefs[t + 1]) == null || i.focus()), (o.code === "ArrowDown" || o.code === "Space") && this.dispatchEvent(
      new CustomEvent("tab-selected", {
        detail: { index: t },
        bubbles: !0,
        composed: !0
      })
    ));
  }
  render() {
    const o = this.useArrowNav ? "tablist" : "navigation";
    return p`
      <div class="pkt-tabs">
        <div class="pkt-tabs__list" role=${o} ${f(this.defaultSlot)}></div>
      </div>
    `;
  }
};
d([
  h({ type: Boolean, reflect: !0, attribute: "arrow-nav" })
], b.prototype, "arrowNav", 2);
d([
  h({ type: Boolean, reflect: !0, attribute: "disable-arrow-nav" })
], b.prototype, "disableArrowNav", 2);
d([
  w()
], b.prototype, "tabRefs", 2);
d([
  w()
], b.prototype, "tabCount", 2);
d([
  R({ context: S }),
  w()
], b.prototype, "context", 2);
b = d([
  y("pkt-tabs")
], b);
const M = b;
var j = Object.defineProperty, q = Object.getOwnPropertyDescriptor, l = (o, t, s, i) => {
  for (var e = i > 1 ? void 0 : i ? q(t, s) : t, n = o.length - 1, r; n >= 0; n--)
    (r = o[n]) && (e = (i ? r(t, s, e) : r(e)) || e);
  return i && e && j(t, s, e), e;
};
let c = class extends $ {
  constructor() {
    super(), this.active = !1, this.href = "", this.icon = "", this.controls = "", this.tag = "", this.tagSkin = "blue", this.index = 0, this.elementRef = x(), this.defaultSlot = x(), this.slotController = new C(this, this.defaultSlot);
  }
  connectedCallback() {
    super.connectedCallback(), this.updateComplete.then(() => {
      this.elementRef.value && this.context && this.context.registerTab(this.elementRef.value, this.index);
    });
  }
  handleClick() {
    this.context && this.context.handleClick(this.index);
  }
  handleKeyUp(o) {
    this.context && this.context.handleKeyUp(o, this.index);
  }
  render() {
    var r;
    const o = ((r = this.context) == null ? void 0 : r.useArrowNav) ?? !0, t = this.active ? "active" : "", s = o ? "tab" : void 0, i = o ? this.active : void 0, e = this.active || !o ? void 0 : -1, n = p`
      ${this.icon ? p`<pkt-icon name=${this.icon} class="pkt-icon--small"></pkt-icon>` : ""}
      <span ${f(this.defaultSlot)}></span>
      ${this.tag ? p`<pkt-tag skin=${this.tagSkin} size="small">${this.tag}</pkt-tag>` : ""}
    `;
    return this.href ? p`
        <a
          ${f(this.elementRef)}
          href=${this.href}
          class="pkt-tabs__link ${t}"
          role=${u(s)}
          aria-selected=${u(i)}
          aria-controls=${u(this.controls || void 0)}
          tabindex=${u(e)}
          @click=${this.handleClick}
          @keyup=${this.handleKeyUp}
        >
          ${n}
        </a>
      ` : p`
      <button
        ${f(this.elementRef)}
        type="button"
        class="pkt-tabs__button pkt-link-button ${t}"
        role=${u(s)}
        aria-selected=${u(i)}
        aria-controls=${u(this.controls || void 0)}
        tabindex=${u(e)}
        @click=${this.handleClick}
        @keyup=${this.handleKeyUp}
      >
        ${n}
      </button>
    `;
  }
};
l([
  h({ type: Boolean, reflect: !0 })
], c.prototype, "active", 2);
l([
  h({ type: String, reflect: !0 })
], c.prototype, "href", 2);
l([
  h({ type: String, reflect: !0 })
], c.prototype, "icon", 2);
l([
  h({ type: String, reflect: !0 })
], c.prototype, "controls", 2);
l([
  h({ type: String, reflect: !0 })
], c.prototype, "tag", 2);
l([
  h({ type: String, reflect: !0, attribute: "tag-skin" })
], c.prototype, "tagSkin", 2);
l([
  h({ type: Number, reflect: !0 })
], c.prototype, "index", 2);
l([
  A({ context: S, subscribe: !0 }),
  h({ attribute: !1 })
], c.prototype, "context", 2);
c = l([
  y("pkt-tab-item")
], c);
const B = c;
export {
  B as P,
  M as a
};
